import { useCallback, useState } from 'react'

import { post } from '@/services/logistics/post'

export const useLogisticsPost = () => {
  const [isLoading, setIsLoading] = useState(false)

  const logisticsPost = useCallback(
    async ({
      arquivo,
      atualizadoPor,
      colaboradores,
      dataLiberacao,
      idFornecedor,
      nomeOperadora,
      numeroPedidoOperadora,
      observacoes,
      operadora,
      pedido,
      postoDeColeta,
      taxaDeRetirada,
      viaDosCartoes
    }: {
      arquivo: File[]
      atualizadoPor: string
      colaboradores: string[]
      dataLiberacao: string
      idFornecedor: string
      nomeOperadora: string
      numeroPedidoOperadora: string
      observacoes?: string
      operadora: string
      pedido: string
      postoDeColeta: string
      taxaDeRetirada: string
      viaDosCartoes: string
    }) => {
      try {
        setIsLoading(true)
        const response = await post({
          arquivo,
          atualizadoPor,
          colaboradores,
          dataLiberacao,
          idFornecedor,
          nomeOperadora,
          numeroPedidoOperadora,
          observacoes,
          operadora,
          pedido,
          postoDeColeta,
          taxaDeRetirada,
          viaDosCartoes
        })

        return response
      } catch (error) {
        return error
      } finally {
        setIsLoading(false)
      }
    },
    []
  )

  return { logisticsPost, isLoading }
}
